import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expand",
  "use": "expand-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"expand\">\n    <path d=\"M16.459 22.129l11.033-11.246-0.917-0.976-10.574 10.663-10.574-10.698-0.917 1.017 11.033 11.24z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol